<template>
  <div style="height: 100%">
    <div style="height: 100%" v-show="!loading">
      <overlay-loading v-model="loadingAll" />
      <EnderecoTable
        class="mt-4"
        :key="tableEndereco"
        :showCheck="opcaoEditar"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        :items="['05', '10', '15']"
        :elementsPerPageProp="'05'"
        :editar="opcaoEditar || $router.history.current.name === 'novaUnimed'"
        @clickButton="(obj) => clickEndereco(obj)"
        @change-page="(obj) => changePage(obj)"
        @change-element="(obj) => changeElement(obj)"
        @ordena="(obj) => changeOrdem(obj)"
        :texto="opcaoEditar == true || $router.history.current.name === 'novaUnimed' ? '+ adicionar outro endereço' : ''"
        ref="table"
      />
      <ExcluirModal
        :showDelete="showDelete"
        :messageDelete="'Tem certeza que deseja excluir esse endereço?'"
        @close="showDelete = false"
        @confirmDelete="deleteEndereco(delSeletected)"
      />
      <SucessoModal :showSucess="showSucess" :sucessType="type" @close="closeSuccess" />
      <error-modal :value="showError" @input="closeError" :errObj="errObj" />
      <EnderecoModal
        ref="enderecoModal"
        :showModal="showModal"
        :formType="type"
        :disable="disabled"
        @showModalControll="(obj) => modalControll(obj)"
        @close="close"
        @finalizar="(obj) => confirm(obj)"
        @new-finalizar="(obj) => newConfirm(obj)"
      />
    </div>
    <component-loading :value="loading" />
  </div>
</template>

<script>
import Enderecos from '@/services/MinhaUnimed/DadosCadastrais/Endereco/Enderecos.js'
import ExcluirModal from './ExcluirModal'
import SucessoModal from './SucessoModal'
import EnderecoModal from './EnderecoModal'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
import EnderecoTable from './EnderecoTable'

export default {
  components: {
    ExcluirModal,
    SucessoModal,
    EnderecoModal,
    ErrorModal,
    EnderecoTable
  },
  data() {
    return {
      rows: [],
      rowsHeader: [
        { text: 'Tipo de Endereço', icon: 'repeat' },
        { text: 'Município', icon: 'repeat' },
        { text: 'UF', icon: 'repeat' },
        { text: 'Região Geográfica', icon: 'repeat' },
        { text: 'End. Principal', icon: 'repeat' }
      ],
      tableEndereco: 0,
      loading: false,
      showDelete: false,
      showSucess: false,
      showModal: false,
      showError: false,
      selected: [],
      delSeletected: [],
      type: '',
      disabled: false,
      successType: '',
      infoUnimed: [],
      pagina: -1,
      qtPaginas: -1,
      qtResultados: -1,
      rowsLength: -1,
      tokenBearer: '',
      uniqueInfoUnimed: {},
      loadingAll: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      ordem: 'desc',
      ordenacao: 'principal'
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.loading = true
    await this.loadEndereco()
    this.loading = false
  },

  methods: {
    closeError() {
      this.showError = false
      if (this.$router.history.current === 'novaUnimed') {
        this.$router.push('/administracao')
      }
    },
    async changeOrdem({ index, ordem }) {
      const ordenacoes = {
        0: 'tipoEndereco.nome',
        1: 'municipio.nome',
        2: 'municipio.regiao.estado.sigla',
        3: 'regiaoGeografica.nome',
        4: 'principal'
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          this.ordenacao = ordenacoes[index]
          this.ordem = ordem
          break

        default:
          this.ordenacao = 'principal'
          this.ordem = 'asc'
          break
      }

      this.loading = true
      await this.loadEndereco()
      this.loading = false
    },
    async closeSuccess() {
      this.showSucess = false
      this.loading = true
      await this.loadEndereco()
      this.loading = false
    },
    async changePage(obj) {
      if (obj.currentPage !== this.pagina) {
        this.rowsLength = obj.elementsPerPage
        this.pagina = obj.currentPage
        this.loading = true
        await this.loadEndereco(
          `?tamanhoPagina=${this.rowsLength}&pagina=${this.pagina}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}`
        )
        this.loading = false
      }
    },
    async changeElement(obj) {
      if (obj.elementsPerPage !== this.rows.length && this.pagina < this.qtPaginas) {
        this.rowsLength = obj.elementsPerPage
        this.loading = true
        await this.loadEndereco(
          `?tamanhoPagina=${this.rowsLength}&pagina=${this.pagina}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}`
        )
        this.loading = false
      } else {
        this.rowsLength = obj.elementsPerPage
        this.loading = true
        await this.loadEndereco(
          `?tamanhoPagina=${this.rowsLength}&pagina=${1}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}`
        )
        this.loading = false
      }
    },
    async loadEndereco(
      args = `?tamanhoPagina=${this.rowsLength}&pagina=${this.pagina}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}`
    ) {
      const enderecos = new Enderecos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await enderecos
        .getEnderecos(args)
        .then(({ data }) => {
          const conteudo = data.conteudo

          this.pagina = data.pagina
          this.qtPaginas = data.qtPaginas
          this.qtResultados = data.qtResultados

          this.rows = []
          this.infoUnimed = []
          conteudo.forEach((el) => {
            this.infoUnimed.push(el)
            this.rows.push({
              id: el.id,
              tipo: el.tipoEndereco.nome,
              cidade: el.municipio.nome,
              estado: el.municipio.regiao.estado.sigla,
              regiaoGeografica: el.regiaoGeografica.nome,
              principal: el.principal
            })
          })

          this.$emit('complete')
        })
        .catch((err) => {
          this.$emit('complete')
          this.showError = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async clickEndereco(obj) {
      let selected = obj.selected
      switch (obj.type) {
        case 'view':
          this.selected = selected
          this.type = 'view'
          this.showModal = true
          this.disabled = true
          await this.$refs.enderecoModal.atribuirDados(this.infoUnimed[obj.index], true)
          break
        case 'edit':
          this.selected = selected
          this.type = 'edit'
          this.showModal = true
          this.disabled = false
          await this.$refs.enderecoModal.atribuirDados(this.infoUnimed[obj.index], true)
          break
        case 'delete':
          this.delSeletected = [this.rows[obj.index].id]
          this.type = 'del'
          this.showDelete = true
          break
        case 'delAll':
          this.delSeletected = obj.selected
          this.type = 'del'
          this.showDelete = true
          break
        case 'add':
          this.type = 'new'
          this.disabled = false
          await this.$refs.enderecoModal.newModal()
          this.showModal = true
          break
        default:
          break
      }
    },
    close() {
      this.showModal = false
      this.selected = []
    },
    async deleteEndereco(obj) {
      let endereco = new Enderecos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      this.showDelete = false
      this.loadingAll = true
      this.selected = []
      this.delSeletected = []
      try {
        await endereco.delEndereco(obj)
        this.loadingAll = false
        this.showSucess = true
        this.rowsLength = 5
        this.pagina = 1
      } catch (err) {
        this.loadingAll = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async modalControll(statusModal) {
      this.showModal = statusModal
    },
    async confirm(obj) {
      this.$refs.enderecoModal.cleanSelected()
      this.loadingAll = true
      this.showModal = false
      this.showDelete = false
      let endereco = new Enderecos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        await endereco.putEndereco(obj)
        await this.loadEndereco()
        this.loadingAll = false
        this.showSucess = true
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.loadingAll = false
        this.showError = true
        console.error(err)
      }
    },
    async newConfirm(obj) {
      this.$refs.enderecoModal.cleanSelected()
      this.showModal = false
      this.loadingAll = true
      let endereco = new Enderecos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        await endereco.putEndereco(obj)
        await this.loadEndereco()
        this.loadingAll = false
        this.showModal = true
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.showError = true
        this.loadingAll = false
        console.error(err)
      }
    }
  },
  watch: {
    showDelete() {
      if (!this.showDelete) {
        this.$refs.enderecoModal.cleanSelected()
      }
    },

    showModal() {
      if (!this.showModal) {
        this.selected = []
        this.delSeletected = []
      }
    },

    showSucess() {
      if (this.showSucess) {
        this.tableEndereco += 1
      }
    }
  }
}
</script>
